import React from 'react'
import TagsCloud from '@site/components/molecules/TagsCloud'
import * as S from './styles'
import { StrapiInfoTags } from '@shared/utils/strapi/strapi.types'
import { Typography } from '@taglivros/tag-components'


const InfoTagsCloud: React.FC<InfoTagsCloud.Props> = ( { infoTags } ) => {
  return (
    <S.Container>
      <S.Title textColor={ infoTags.titleColor }>
        <Typography
          as="h2"
          variant="custom-text"
          fontFamily="robotoSlab"
          fontWeight="xs"
          fontSizeDesktop="s"
          fontSizeMobile="s"
        >
          { infoTags.title }
        </Typography>
      </S.Title>
      <TagsCloud
        tagDataList={ infoTags.infoTags }
      />
    </S.Container>
  )
}

namespace InfoTagsCloud {
  export interface Props {
    infoTags: StrapiInfoTags
  }
}

export default InfoTagsCloud
